import { render, staticRenderFns } from "./DefPolStatHelplist.vue?vue&type=template&id=46b6ad6e&"
import script from "./DefPolStatHelplist.vue?vue&type=script&lang=js&"
export * from "./DefPolStatHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports